/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentFileContent
 */
export interface AttachmentFileContent {
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof AttachmentFileContent
     */
    buffer: object;
    /**
     * 
     * @type {string}
     * @memberof AttachmentFileContent
     */
    filename: string;
}

/**
 * Check if a given object implements the AttachmentFileContent interface.
 */
export function instanceOfAttachmentFileContent(value: object): value is AttachmentFileContent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('buffer' in value) || value['buffer'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function AttachmentFileContentFromJSON(json: any): AttachmentFileContent {
    return AttachmentFileContentFromJSONTyped(json, false);
}

export function AttachmentFileContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentFileContent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'buffer': json['buffer'],
        'filename': json['filename'],
    };
}

export function AttachmentFileContentToJSON(value?: AttachmentFileContent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'buffer': value['buffer'],
        'filename': value['filename'],
    };
}

